/**
 * 版本管理相关api
 */
import * as API from './'
import $const from "../common/constant"

export default {

  //查询获取role列表(通过page分页)
  findList: params => {
    return API.GET($const.apiServer.Base+'/version/list', params)
  },

  //查询获取一条role信息
  findById: id => {
    return API.GET($const.apiServer.Base+'/version/getById?id='+id)
  },

  add: params => {
    return API.POST($const.apiServer.Base+'/version/add', params)
  },
  update: (id, params) => {
    return API.PUT($const.apiServer.Base+'/version/update', params)
  },
  //修改或添加
  save:params=>{
    return API.POST($const.apiServer.Base+'/version/save', params)
  },

  remove:params=>{
    return API.DELETE($const.apiServer.Base+'/version/remove',  params)
  },
  newestData:()=>{
    return API.GET($const.apiServer.Base+'/version/newestData')
  },
}



// WEBPACK FOOTER //
// ./src/api/api_version.js